<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.proofs_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Comprobantes de pago</v-toolbar-title>
            </v-toolbar>
            <v-container class="py-0" fluid>
                <v-row>
                    <v-col cols="12" class="pa-0">
                        <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
                    </v-col>
                    <v-col lg="8" class="mx-auto" style="position:relative; top: -60px">
                        <v-card>
                            <v-card-title> <v-icon class="mr-2">mdi-receipt</v-icon> Registrar comprobante de pago</v-card-title>
                            <v-card-text>
                                <v-row justify="center" align="center">
                                    <v-col lg="6" md="8" sm="12" class="text-center">
                                        <p class="text-center">Para agilizar el proceso de verificación, por favor ingresa la cantidad que fue depositada correctamente.</p>
                                        <v-form v-model="form" ref="proof_create" v-on:submit.prevent="submit">
                                            <v-text-field v-model="quantity" filled :color="color" :rules="[rules.required]" prepend-inner-icon ="mdi-currency-usd" type="number" min="1" label="Cantidad depositada"></v-text-field>
                                            <v-file-input v-model="proof[0]" filled :color="color" :rules="[rules.required]" prepend-icon="" label="Seleccionar comprobante de pago"></v-file-input>
                                            <v-btn block color="#008dd4" dark :loading="loading" @click="submit">Registrar comprobante</v-btn>
                                        </v-form>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <v-card class="mt-4">
                            <v-card-title>Comprobantes registrados</v-card-title>
                            <v-card-text v-if="Object.keys(proofs).length > 0">
                                <v-list three-line>
                                    <template v-for="(proof, index) in proofs">
                                        <v-list-item :key="index">
                                            <v-list-item-avatar size="70">
                                                <v-img :src="image_proof_url+proof.proof" @click="proofDialog(proof)" style="cursor: pointer"></v-img>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <v-chip class="mr-2" v-if="proof.validated == 0 && proof.status == 1" color="primary" small>
                                                        <span class="d-none d-sm-flex">
                                                            Pendiente de validación
                                                        </span>
                                                    </v-chip>
                                                    <v-chip class="mr-2" v-else-if="proof.validated == 0 && proof.status == 0" color="error" small>
                                                        <span class="d-none d-sm-flex">
                                                            Error de validación
                                                        </span>
                                                    </v-chip>
                                                    <v-chip class="mr-2" v-else-if="proof.validated == 1 && proof.status == 0" color="success" small>
                                                        <span class="d-none d-sm-flex">
                                                            Validación correcta
                                                        </span>
                                                    </v-chip>
                                                    {{ proof.date }}
                                                </v-list-item-title>
                                                <v-list-item-subtitle>ID de comprobante : {{ proof.folio }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-list-item-action-text>MXN{{ proof.quantity }}{{ proof.quantity % 1 === 0 ? '.00' : '' }}</v-list-item-action-text>
                                                <v-btn color="error" small v-if="proof.validated == 0 && proof.status == 0" @click="refusedProof(proof)">Reporte</v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-divider :key="index+1" v-if="index < Object.keys(proofs).length-1"></v-divider>
                                    </template>
                                </v-list>
                            </v-card-text>
                            <v-card-text v-else>
                                <p class="text-center">Aún no tienes comprobantes registrados.</p>
                            </v-card-text>
                        </v-card>

                    </v-col>
                </v-row>

                <v-dialog v-model="proof_dialog" scrollable width="800">
                    <v-card>
                        <v-card-title class="headline" style="background-color: #008dd4; color: white">
                            Comprobante
                        </v-card-title>

                        <v-card-text>
                            <v-img :src="image_url"></v-img>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="proof_dialog = false">
                                Cerrar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="refused_proof_dialog" scrollable width="800">
                    <v-card>
                        <v-card-title class="headline" style="background-color: #ff5252; color: white"></v-card-title>
                        <v-card-text class="pb-0">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" v-if="selected_proof">
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <tbody>
                                                    <tr>
                                                        <td><strong>Cantidad ingresada</strong></td>
                                                        <td>MXN{{ selected_proof.quantity }}{{ selected_proof.quantity % 1 === 0 ? '.00' : '' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td><strong>Fecha de cancelación</strong></td>
                                                        <td>{{ selected_proof.refuse.date }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                        <v-alert class="mt-3" border="right" colored-border type="error" elevation="2">
                                            {{ selected_proof.refuse.reason }}
                                        </v-alert>
                                        <v-divider></v-divider>
                                        <p class="text-center mt-3"><i>Si usted cree que se trata de un error, por favor reenvie el comprobante.</i></p>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#000" text @click="refused_proof_dialog = false">
                                Cerrar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog','proofs','store_url'],
    data: () => ({
        form:false,
        color:"#000",
        loading:false,
        image_proof_url:"/storage/payment_proofs/",
        image_url:"",
        proof_dialog:false,
        refused_proof_dialog:false,
        selected_proof:"",
        rules:{
            required: v => !!v || 'El campo es requerido',
        },

        quantity:"",
        proof:[],

    }),

    methods:{
        submit:function(){
            if(this.$refs.proof_create.validate()){
                let data = new FormData()
                data.append('quantity', this.quantity)
                data.append('proof', this.proof[0])

                this.loading = true
                axios.post(this.store_url, data).then(response => {
                    this.cancel()
                    iziToast.success({
                        position:"topRight",
                        title:'Correcto',
                        message:'Comprobante registrado correctamente'
                    })

                    this.$parent.getData()
                }).catch(error => {
                    this.cancel()
                    iziToast.error({
                        position:'topRight',
                        title:'Error',
                        message:'Ha ocurrido un error al registrar el comprobante, intente más tarde.'
                    })
                })
            }
        },

        proofDialog:function(proof){
            this.image_url = "/storage/payment_proofs/"+proof.proof
            this.proof_dialog = true
        },

        refusedProof:function(proof){
            this.selected_proof = proof
            this.refused_proof_dialog = true
        },

        cancel:function(){
            this.$refs.proof_create.reset()
            this.loading = false
        }
    }
}
</script>
